import { KeyValueModel } from "model";

export enum EnumSistemasRoadmap {
    PDV_App = "PDV App",
    PDV_Mobile = "PDV Mobile",
    Retaguarda_App = "Retaguarda.App (v4)",
    Terminal_Pre_Venda_Windows = "Terminal Pré-Venda Windows",
    TouchOne = "TouchOne",
    Comandas = "Comandas Mobile",
    Licenciamento = "Licenciamento",
    Outros = "Outros",
}

export enum EnumSistemasHistorico {
    PDVApp = 21,
    PDVMobile = 60,
    S2PayMobile = 61,
    Transmissor = 5,
    RetaguardaApp = 4,
    TerminalPreVendaWindows = 12,
    ImpressorLocalV4 = 22,
    TouchOne = 70,
    TouchoneRetaguarda = 71,
    TouchonePDV = 72,
    CardapioTouchOne = 73,
    ImpressorTouchOne = 74,
    Cartorio = 75,
    Comandas = 63,
    PedApi = 23,
    PedidosMobile = 62,
}

export const SistemasRoadmapMock = [
    new KeyValueModel(EnumSistemasRoadmap.PDV_App, "Saurus PDV"),
    new KeyValueModel(EnumSistemasRoadmap.PDV_Mobile, "Saurus Mobile"),
    new KeyValueModel(EnumSistemasRoadmap.Retaguarda_App, "Saurus V4"),
    new KeyValueModel(EnumSistemasRoadmap.Terminal_Pre_Venda_Windows, "Pré-Venda Local"),
    new KeyValueModel(EnumSistemasRoadmap.TouchOne, "TouchOne"),
    new KeyValueModel(EnumSistemasRoadmap.Comandas, "Comandas"),
    // new KeyValueModel(EnumSistemasRoadmap.Licenciamento, "Licenciamento"),
    // new KeyValueModel(EnumSistemasRoadmap.Outros, "Outros"),
]

export const SistemasHistoricoMock = [
    new KeyValueModel(EnumSistemasHistorico.PDVApp, "Saurus PDV"),
    new KeyValueModel(EnumSistemasHistorico.PDVMobile, "Saurus Mobile"),
    new KeyValueModel(EnumSistemasHistorico.S2PayMobile, "S2Pay Mobile"),
    new KeyValueModel(EnumSistemasHistorico.Transmissor, "Transmissor"),
    new KeyValueModel(EnumSistemasHistorico.RetaguardaApp, "Saurus V4"),
    new KeyValueModel(EnumSistemasHistorico.TerminalPreVendaWindows, "Pré-Venda Local"),
    new KeyValueModel(EnumSistemasHistorico.ImpressorLocalV4, "Impressor Local V4"),
    new KeyValueModel(EnumSistemasHistorico.TouchOne, "TouchOne"),
    new KeyValueModel(EnumSistemasHistorico.TouchoneRetaguarda, "Touchone Retaguarda"),
    new KeyValueModel(EnumSistemasHistorico.TouchonePDV, "Touchone PDV"),
    new KeyValueModel(EnumSistemasHistorico.CardapioTouchOne, "Cardápio"),
    new KeyValueModel(EnumSistemasHistorico.ImpressorTouchOne, "Impressor TouchOne"),
    // new KeyValueModel(EnumSistemasHistorico.Cartorio, "Cartório"),
    new KeyValueModel(EnumSistemasHistorico.Comandas, "Comandas"),
    // new KeyValueModel(EnumSistemasHistorico.PedApi, "Pedidos Api"),
    new KeyValueModel(EnumSistemasHistorico.PedidosMobile, "Pedidos Mobile"),
]